import $ from '../../../../../FrontendBundle/Resources/js/jquery';
import AbstractField from './abstractField';

/**
 * @class InputField
 */
export default class InputField extends AbstractField {
    type = 'input';
    supports = null;

    /**
     * `<div/>` container of field
     *
     * @property {jQuery} control
     */

    /**
     * `<input/>` element of field
     *
     * @property {jQuery} input
     */

    /**
     * Initializes the field
     *
     * @param {jQuery} control `<div/>` container of field
     * @param {Object} translations
     */
    constructor(control, translations) {
        super(control, translations);

        this.input = $('input', control);

        this.assertElementIsUnique(this.input, this.type, 'input');
        this.registerEventsForInput(this.input);
    }

    /**
     * Register key events on input field.
     *
     * @param {jQuery} input
     */
    registerEventsForInput(input) {
        input.on('keydown', event => event.stopPropagation());

        input.on('keyup', ({ keyCode }) => {
            if (keyCode === 13 || keyCode === 9) { // enter || tab key
                this.tryUpdateItem(this.currentItem);
            } else if (keyCode === 27) { // esc key
                input.val(this.startValue);
                this.tryUpdateItem(this.currentItem);
            }
        });

        input.on('focusin', () => (this.startValue = input.val()));
        input.on('focusout', () => this.tryUpdateItem(this.currentItem));
    }

    /**
     * Set input field value.
     *
     * @param {number} value
     */
    setValue(value) {
        this.input.val(value);
    }

    /**
     * Get input field value.
     *
     * @return {number}
     */
    getValue() {
        return this.input.val();
    }
}
